import {BaseDigitalSigningComponent} from './base-component';

export class DticketDigitalSigningComponent extends BaseDigitalSigningComponent {
  constructor(enabled = false, canSignManually = false, moduleEnabled = false) {
    super('dticket','D-Ticket', 'garage', enabled, canSignManually, moduleEnabled);
  }
}
